// extracted by mini-css-extract-plugin
module.exports = {"root":"IconExtraCustom_root__1zIaQ"};